import Head from "next/head";
import type {NextPage} from "next";
import {CustomerView} from "../components/customer/CustomerView";
import {useRouter} from "next/router";
import axios from "axios";
import {handleLogout} from "components/utils"; import React, {useEffect, useState} from "react";
import * as ga from "../lib/gtag";

const Customer: NextPage = (props) => {

    const router = useRouter()
    const qrCode = router.query["qr"] ? router.query["qr"].toString() : null
    const filterq = router.query["filterq"] ? router.query["filterq"].toString() : null
    const [clientProfileEntities, setClientProfileEntities] = useState<[]>(null)
    const [businessName, setBusinessName] = useState(null)
    const [businessAddress, setBusinessAddress] = useState(null)
    const [isQmeEnabled, setIsQmeEnabled] = useState(false)

    useEffect(() => {
        if (qrCode) {
            // log scan action event
            ga.event({
                action: "qr-scan",
                params : {
                    qr_code: qrCode
                }
            });

            axios.get('/api/backend/entity/profile/qr/scan/' + qrCode)
                .then(resp => {
                    console.log(JSON.stringify(resp))
                    if (!resp.data.fetched) {
                        window.location.href = window.location.origin + "/admin?qr=" + qrCode
                    } else {
                        let clientProfiles = resp.data.clientProfileEntities
                       if (filterq) {
                           clientProfiles  = clientProfiles.filter(value => value.qrCode == filterq)
                       }
                        setClientProfileEntities(clientProfiles)
                        setBusinessName(resp.data.businessName)
                        setBusinessAddress(resp.data.businessAddress)
                        setIsQmeEnabled(resp.data.qmeEnabled)
                    }
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
                });
        }
    }, [qrCode, filterq])

    return (
        <div>
            <Head>
                <title>QMe - Book an appointment</title>
                <meta name="description" content="QMe - Book an appointment"/>
                <meta name="keywords" content="queue management software, opd management software, online appointment"/>
                <meta name="robots" content="noindex, nofollow"/>
            </Head>
            <div className="row bg-white">
                <div className="col col-lg-8 offset-lg-2">
                    <CustomerView clientProfiles={clientProfileEntities} businessName={businessName} businessAddress={businessAddress} isQmeEnabled={isQmeEnabled}/>
                </div>
            </div>
        </div>
    );
};


export default Customer;
